/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  Filter module selectors
 */

import type { State } from '@zcode/state-type'
import { compose } from 'redux'
import { getFilterCount } from '../../../helpers'

export const selectRoot = (state: State) => state?.filters

export const selectMeta = compose((state) => state.meta, selectRoot)

export const selectDirty = compose((meta) => meta.dirty, selectMeta)

export const selectListablesCount = compose((state) => state.listablesCount, selectRoot)

export const selectFilters = compose((state) => state.filters, selectRoot)

export const selectSortCopy = compose((filters) => {
  if (filters.sort?.length === 0) {
    return 'Relevance'
  }
  if (filters.sort?.[0] === 'newest') {
    return 'Newest'
  }
  if (filters.sort?.[0] === 'price') {
    return 'Lowest price'
  }
  if (filters.sort?.[0] === '-price') {
    return 'Highest price'
  }
  if (filters.sort?.[0] === 'rating') {
    return 'Lowest rating'
  }
  if (filters.sort?.[0] === '-rating') {
    return 'Highest rating'
  }
  return 'Relevance'
}, selectFilters)

export const selectNeighborhoodIds = compose((state) => state.neighborhoodIds, selectFilters)

export const selectListablesCountData = compose((state) => state.data, selectListablesCount)

export const selectFilterEndDate = compose((state) => state.endDate, selectFilters)

export const selectFilterStartDate = compose((state) => state.startDate, selectFilters)

export const selectFilterCount = compose((filters) => getFilterCount(filters), selectFilters)

export const selectFiltersChanged = compose((state) => state.filtersChanged, selectRoot)

export const selectMaxBedrooms = compose(
  (state) =>
    state.bedrooms.reduce((maxRooms: null | number, currentVal, currentIndex) => {
      if (currentVal) {
        maxRooms = currentIndex
      }
      return maxRooms
    }, null),
  selectFilters
)

// FILTER MODAL

export const selectFilterModal = compose((state) => state.filterModal, selectRoot)

export const selectFilterModalType = compose((state) => state?.filterModalType, selectFilterModal)

export const selectIsFilterModalOpen = compose(
  (state) => state?.isFilterModalOpen,
  selectFilterModal
)
export const selectAnyFilterSet = (state: State) => !selectDirty(state)

export const selectLongTerm = compose((state) => state.longTerm, selectFilters)

export const selectFilterMatchingCount = compose((state) => state.matchingCount, selectRoot)

export const selectMatchingCountFetching = compose((meta) => meta.matchingCountFetching, selectMeta)

// ZOE SEARCH

export const selectIsZoeSearch = compose((meta) => meta.isZoeSearch, selectMeta)
export const selectZoeLocation = compose((meta) => meta.zoeLocation, selectMeta)
